export const PlayingStatus = {
    NOT_PLAYED: 1,
    IN_PROGRESS: 2,
    COMPLETED: 3,
    OLD: 4,
} as const;
